const StableBookingsRepeatingPermission = {
    ALLOWED : "StableBookingsRepeatingPermission.ALLOWED",
    DISABLED: "StableBookingsRepeatingPermission.DISABLED",
};



export default StableBookingsRepeatingPermission;
